import { createSlice } from "@reduxjs/toolkit";

interface AddCreditDrawerState {
  isOpen: boolean;
}

const initialState: AddCreditDrawerState = {
  isOpen: false,
};

const addCreditDrawerSlice = createSlice({
  name: "addCreditDrawer",
  initialState,
  reducers: {
    openDrawer: (state) => {
      state.isOpen = true;
    },
    closeDrawer: (state) => {
      state.isOpen = false;
    },
    toggleDrawer: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openDrawer, closeDrawer, toggleDrawer } =
  addCreditDrawerSlice.actions;

export default addCreditDrawerSlice.reducer;
